export const setSessionCookie = (key, value) => {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.log("Error: Could not set auth cookie for user.");
    }
};
